/**
 * Deal presentation helpers (PRIVATE fork) — kept in the CRM module rather than
 * the upstream `lib/utils` (which stays byte-identical to upstream). Reuses the
 * core `TagTone` palette so deal-stage badges match the rest of the UI.
 */

import type { TagTone } from '../../lib/utils';

/** Deal stage → Tag tone (draft/sent/negotiating/won/lost/cancelled). */
export const DEAL_STAGE_TONE: Record<string, TagTone> = {
  draft: 'primary',
  sent: 'neutral',
  negotiating: 'warning',
  won: 'success',
  lost: 'danger',
  cancelled: 'neutral',
};
